import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import FadeLoader from 'react-spinners/FadeLoader';
import { css } from '@emotion/core';

const override = css`
    display: block;
    margin: 2px auto;
    border-color: red;
`;

const useStyles = makeStyles(theme => ({
    appTopBar: {
        top: 0,
        bottom: 'auto',
    },
    grow: {
        flexGrow: 1,
    },
    labelOne: {
        fontSize: 40,
        fontWeight: 'bold',
        fontFamily: 'effra',
        color: '#1A237A',
    },
    labelTwo: {
        fontSize: 24,
        fontWeight: 'regular',
        fontFamily: 'effra',
        color: '#69737A',
    },
    align: {
        textAlign: 'center',
    },
}));

const LoadingScreen = () => {

    const classes = useStyles();
    return (
        <Grid container spacing={4}>
                <img src={require('./../assets/Contele-Fleet-Tracking.png')} alt="" className="topLogoImage" />
                <AppBar position="fixed" color="inherit" className={useStyles.appTopBar}>
                <Toolbar>
                    <div className={classes.grow} />
                </Toolbar>
            </AppBar>
            <Grid item xs={12} sm={12}>
                <FadeLoader
                    css={override}
                    sizeUnit={"px"}
                    color={'#123abc'}
                    loading={true}
                />
            </Grid>
            <Grid item xs={12} sm={12} className={classes.align}>
                <label className={classes.labelOne}>Please Wait...</label>
            </Grid>
            <Grid item xs={12} sm={12} className={classes.align}>
                <label className={classes.labelTwo}>We are processing your order.</label>
            </Grid>
        </Grid>
    );
};

export default LoadingScreen